<template lang="html">
	<div class="inner-modal">
		<div class="head-modal row">
			<div class="left">
				<div class="head-modal-title">
					Nouveau message
				</div>
				<div class="head-modal-emphase">
					Répondre à votre {{ (data.isAdvisor) ? 'client' : 'patrimofficer' }}
				</div>
			</div>
		</div>
		<div class="body-modal">
			<form class="form-ui column default-form-ui need-big">
				<div class="form-elem-container in-modal">
					<div class="ctn-textarea ctn-label" v-inputUI :class="{error: errors.has('body')}">
						<label for="body">Message</label>
						<textarea v-validate="'required'" type="text" name="body" v-model="message"></textarea>
					</div>
					<div v-if="errors.has('body')" class="error-message">{{ errors.first('body') }}</div>
				</div>
				<div class="ctn-cta right row">
					<div class="btn btn-gold" @click="close">Annuler</div>
					<div class="btn btn-red" @click="send">Envoyer</div>
				</div>
			</form>
		</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
	name: 'newMessage',
	props: ['data'],
	data () {
		return {
			message: null
		}
	},
	mounted () {
		console.log('Data New Message : ', this.data)
	},
	methods: {
		close () {
			this.$emit('close')
		},
		send () {
			this.$validator.validate().then((validation) => {
				if (validation) {
					this.$store.dispatch('newMessage', {
						request: {
							title: null,
							body: this.message,
							thread_id: this.data.request.threadId,
							user_id: this.data.request.userId
						},
						side: {
							id: this.user.id,
							first_name: this.user.firstname,
							last_name: this.user.lastname
						}
					}).then(() => {
						this.$emit('close')
					}).catch((error) => {
						console.warn(error)
					})
				}
			})
		}
	},
	computed: {
		...mapGetters({
			user: 'user'
		})
	}
}
</script>

<style lang="scss" scoped>
.head-modal {
	justify-content: flex-start;
}

.body-modal {
	padding-top: 0.5rem!important;

	form {
		align-items: flex-start;
		.form-elem-container {
			width: 100%;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/common/components/Modal/NewMessage.vue